module.exports = {"bmsLogicUrl":"http://vpp-coredev-qa1.inseincvirtuals.com/bms-logic","nextEventDisplayMode":"DEFAULT","customization":false}


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/bmsLogicConfig.json
// module id = 302
// module chunks = 0